// Report, export, check-in and polling rules shared by the server and the client bundle
// (architecture sprint-04 §3.3). Dependency-free constants only (shared-purity.test.ts).

/** Reports and export: to − from must be < this many days (≤ 366 calendar days inclusive). */
export const MAX_REPORT_RANGE_DAYS = 366;
/** The heatmap: 365 days ending today (from = today − 364). Labelled "Last 12 months". */
export const HEATMAP_DAYS = 365;
/** Export rows above this → 422 EXPORT_TOO_LARGE. */
export const MAX_EXPORT_ROWS = 10_000;
export const CHECKIN_INTERVAL_MINUTES = [15, 30, 45, 60] as const;
/** Live data refresh (S5.8). */
export const LIVE_REFETCH_MS = 30_000;
/** Heatmap bucket upper bounds in seconds: 0 | (0,2h) | [2h,4h) | [4h,6h) | ≥6h. */
export const HEATMAP_BUCKET_BOUNDS = [7_200, 14_400, 21_600] as const;
/** Report presets in days (inclusive, ending today). 'month' and 'last-month' are calendar-based. */
export const REPORT_PRESET_DAYS = { '7d': 7, '30d': 30, '3m': 91, '12m': 365 } as const;
export const DEFAULT_REPORT_PRESET = '30d';

// ── Sprint 5 (architecture sprint-05 §3.7) ──
/** Team report presets resolve to FULL calendar periods (A-2, owner-confirmed). */
export const TEAM_REPORT_PRESETS = ['this-week', 'last-week', 'this-month', 'last-month'] as const;
export const DEFAULT_TEAM_REPORT_PRESET = 'this-month';
/** Tracker default: this week up to today. */
export const TRACKER_PRESETS = ['this-week', 'last-week'] as const;
/** Records default: last 30 days inclusive, ending today. */
export const RECORDS_DEFAULT_DAYS = 30;
export const RECORDS_PAGE_SIZES = [25, 50, 100] as const;
export const RECORDS_DEFAULT_PAGE_SIZE = 50;
export const RECORDS_MAX_PAGE = 10_000;
export const SHARE_LINK_EXPIRY_DAYS = 30;
